import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { HeaderMonTechComponent } from './shared/header-mon-tech/header-mon-tech.component';
import { PrivilegesModules } from '@core/privileges/privileges-modules';

const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Monitoring,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Monitoring,
        title: marker('modules.monitoring.head'),
        loadComponent: () => import('./features/monitoring-tech/monitoring-tech.component').then((c) => c.MonitoringTechComponent),
        canLoad: [AuthGuard],
        data: {
            moduleMenu: {
                objName: [PrivilegesModules.ValmanMonitoring],
            },
        },
    },
    ...commonErrorRoutes,
];

const headerRoutes: Route = routes.find((route) => route.outlet === 'header');
headerRoutes.component = HeaderMonTechComponent;

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
